import type { ITestimonialGridBlockProps } from "./TestimonialGridBlock.props";
import { TestimonialGridStandard } from "../../../../modules/testimonial-grid/components/TestimonialGridStandard/TestimonialGridStandard";

export const TestimonialGridBlock = (props: ITestimonialGridBlockProps) => {
  if (!props.items?.length) {
    return null;
  }

  return <TestimonialGridStandard {...props} />;
};

TestimonialGridBlock.displayName = "Block::TestimonialGridBlock";
